<div class="context-menu" *ngIf="showContextMenu" [style.left.px]="contextMenuPosition.x" [style.top.px]="contextMenuPosition.y">
  <ul>
    <li (click)="onEditClick()"><a href="javascript:void(0)" (click)="onEditClick()">Edit</a></li>
    <li (click)="onEditClick()"><a href="javascript:void(0)" (click)="onEditClick()">View</a></li>
  </ul>
</div>
